export function addData(payload){
    
    return{
        type:'ADD_DATA',
        payload:payload
    }
}

export const deleteData = (index) => {
    return {
      type: 'DELETE_DATA',
      payload: index,
    };
  };

export  const updateStatus =(task,status)=>{
  return{
    type: 'UPDATE STATUS',
    payload:{task,status}
  };
}  
  